import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=4755adfe&"
import script from "./factory.vue?vue&type=script&lang=js&"
export * from "./factory.vue?vue&type=script&lang=js&"
import style0 from "./factory.vue?vue&type=style&index=0&id=4755adfe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports